import { Search, X } from 'lucide-react';
import React, { useState } from 'react';
import { TextInput } from './TextInput';
import type { InputProps } from 'react-aria-components';
import { useDebouncedCallback } from '~/shared/hooks/useDebouncedCallback';

export interface SearchInputProps extends Omit<InputProps, 'onChange'> {
	onClear?: () => void;
	onChange: (value: string) => void;
	debounceMs?: number;
}

export function SearchInput({ onClear, value, onChange, debounceMs = 0, ...props }: SearchInputProps) {
	const [localValue, setLocalValue] = useState(value ?? '');
	const [prevValue, setPrevValue] = useState(value);

	const debouncedOnChange = useDebouncedCallback((x: string) => onChange(x), debounceMs);

	if (value !== prevValue) {
		setPrevValue(value);
		setLocalValue(value ?? '');
	}

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (debounceMs > 0) {
			setLocalValue(event.target.value);
			debouncedOnChange(event.target.value);
			return;
		}
		onChange(event.target.value);
	};
	return (
		<div className="relative w-full">
			<Search className="absolute left-3 top-1/2 size-5 -translate-y-1/2 text-gray-400" />
			<TextInput
				className="py-2.5 pl-10 pr-4"
				{...props}
				value={localValue}
				onChange={handleChange}
			/>
			{onClear && (
				<button type="button" onClick={onClear} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
					<X className="size-5" />
				</button>
			)}
		</div>
	);
}
